var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.12 31.76C16.72 31.9 17.34 32 18 32C19.64 32 21.18 31.5 22.46 30.64L28.92 36.38C27.98 38.2 27.64 40.36 28.5 42.72C29.46 45.32 31.74 47.36 34.48 47.86C39.56 48.8 44 44.92 44 40C44 37.6 42.92 35.46 41.24 34L46.34 23.82C48.1 24.2 50.06 24.06 52.16 22.76C54 21.64 55.4 19.8 55.84 17.7C57.02 11.96 52.02 6.96 46.26 8.2C43.34 8.82 40.96 11.16 40.26 14.04C39.48 17.22 40.66 20.14 42.78 22L37.68 32.18C37.14 32.06 36.58 32 36 32C34.36 32 32.82 32.5 31.54 33.36L25.08 27.62C26.02 25.8 26.36 23.64 25.5 21.28C24.54 18.68 22.26 16.64 19.52 16.14C14.44 15.2 10 19.08 10 24C10 26.32 11.02 28.4 12.6 29.86L4 46V0H0V52C0 54.2 1.8 56 4 56H56V52H5.34L16.14 31.76H16.12ZM48 12C50.2 12 52 13.8 52 16C52 18.2 50.2 20 48 20C45.8 20 44 18.2 44 16C44 13.8 45.8 12 48 12ZM40 40C40 42.2 38.2 44 36 44C33.8 44 32 42.2 32 40C32 37.8 33.8 36 36 36C38.2 36 40 37.8 40 40ZM18 20C20.2 20 22 21.8 22 24C22 26.2 20.2 28 18 28C15.8 28 14 26.2 14 24C14 21.8 15.8 20 18 20Z",
    fill: "url(#paint0_linear_14613_318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14613_318",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C80EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserData);
export default __webpack_public_path__ + "static/media/userData.b0d7fa8791380d43a13fe55695672310.svg";
export { ForwardRef as ReactComponent };